import { waitUntil } from '@atc/wait-until';
const emitAnalyticsEvent = (type, data) => {
  waitUntil(
  // The waiting mostly help the impressions happened on page load
  () => window.caiEventBus.all.get(`analytics:${type}`) && window.caiEventBus.all.get(`analytics:${type}`).length >= 1, () => window.caiEventBus.emit(`analytics:${type}`, data), 30, 2000, () => {
    // eslint-disable-next-line no-console
    console.error(`Failed to set up listener for analytics:${type}`);
  });
};
export const sendClick = (type, event, data) => {
  emitAnalyticsEvent('sendClick', {
    type,
    event,
    data
  });
};
export const sendDomReadyEvent = event => {
  emitAnalyticsEvent('sendDomReadyEvent', event);
};
export const sendEvent = event => {
  emitAnalyticsEvent('sendEvent', event);
};
export const sendImpressions = event => {
  emitAnalyticsEvent('sendImpressions', event);
};
export const sendPage = event => {
  emitAnalyticsEvent('sendPage', event);
};
export const sendThirdPartyEvent = event => {
  emitAnalyticsEvent('sendThirdPartyEvent', event);
};